import AnimationMotionBlur from "components/global/animation-motion-blur"
import styles from './styles.module.scss'
import { CopyButtonWithSuccess } from "components/ui/copy-button-with-success"
import CopyIcon from 'images/account/copy.svg'

import cn from 'classnames'
import { useTranslation } from "utils/use-translation"

const CopyId = ({ id, className = '' }) => {
    const { t } = useTranslation()

    return (
        <section className={cn(styles.wrapper, className)}>
            <span className={styles.label}>{t('id')}</span>
            {id ? <span>{id}</span> : <div className={cn(styles['motion-blur'])}>
                <AnimationMotionBlur />
            </div>}
            {id &&
                <CopyButtonWithSuccess value={id} className={styles.btn__copy} customIcon={CopyIcon} />
            }
        </section>
    )
}

export default CopyId